import { Injectable, signal } from '@angular/core';
import { ToastMessage, ToastType } from './toast.model';

@Injectable({ providedIn: 'root' })
export class ToastService {
  private readonly _toasts = signal<ToastMessage[]>([]);
  private nextId = 1;

  readonly toasts = this._toasts.asReadonly();

  show(title: string, type: ToastType = 'info', message?: string, durationMs = 4200): void {
    const id = this.nextId++;
    this._toasts.update((items) => [...items, { id, type, title, message }]);

    window.setTimeout(() => this.dismiss(id), durationMs);
  }

  dismiss(id: number): void {
    this._toasts.update((items) => items.filter((item) => item.id !== id));
  }
}
